import React from 'react';

const AppFooter = () => {
    return (
        <div className="layout-footer" style={{"backgroundColor": "#343a40"}}>
            <div className="footer-logo-container">
                <img id="footer-logo" src="https://dekkoisho.com/wp-content/uploads/2021/08/cropped-dekkoisho-icon-512x512-1-32x32.png" alt="Dekko-Isho-Group" />
                <span className="app-name" style={{"color": "white"}}>Astha Shop</span>
            </div>
            <span className="copyright"  style={{"color": "white"}}>&#169; Dekko Isho Group - 2023</span>
        </div>
    );
};

export default AppFooter;
